import { render, staticRenderFns } from "./insure_detail.vue?vue&type=template&id=7a965923&scoped=true"
import script from "./insure_detail.vue?vue&type=script&lang=js"
export * from "./insure_detail.vue?vue&type=script&lang=js"
import style0 from "./insure_detail.vue?vue&type=style&index=0&id=7a965923&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a965923",
  null
  
)

export default component.exports